import { getLangText } from 'utils/langText';

export const showQuestionModal = (idToUpdate, upsells, changes) => {
  const upsellNamesList =
    upsells
      ?.filter((upsell) => upsell.id !== idToUpdate)
      .map((upsell) => getLangText(upsell.name).toLowerCase()) ?? [];

  const upsellName = getLangText(changes?.nameLang?.value);

  if (
    upsellName &&
    upsellName.length > 0 &&
    upsellNamesList.some((upsell) => upsell === upsellName.toLowerCase())
  ) {
    return true;
  }
  return false;
};
